import classNames from 'classnames';
import { useField } from 'formik';

interface CheckboxRowFieldProps {
    name: string;
    label: string;
    disabled?: boolean;
    wrapperClassName?: string;
}

export function CheckboxRowField({ name, label, disabled, wrapperClassName }: CheckboxRowFieldProps) {
    const [field] = useField({ name, type: 'checkbox' });

    return (
        <div className={classNames('data-item-row', wrapperClassName)}>
            <label className="data-item-col data-item-col-title data-item-capitalize" htmlFor={name}>
                {label}
            </label>
            <div className="data-item-col">
                <div
                    className={classNames('checkbox', { disabled })}
                    onClick={e => e.stopPropagation()}
                >
                    <input
                        {...field}
                        id={name}
                        disabled={disabled}
                        type="checkbox"
                        value={field.value ?? ''}
                    />
                    <label htmlFor={name} className="checkbox-lbl" />
                </div>
            </div>
        </div>
    );
}
